import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserMenuComponent } from '../../../auth/components/user-menu/user-menu.component';
import { MenuList } from '../../interfaces/menuList.interface';

@Component({
  selector: 'app-shared-nav',
  imports: [CommonModule, RouterModule, UserMenuComponent],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class NavComponent {
  public listMenu: MenuList[] = [
    { title: 'Cartelera', route: '/cartelera' },
    { title: 'Confíteria', route: '/confiteria' },
    { title: 'Próximamente', route: '/proximamente' },
  ];

  isMenuOpen = false;
  @ViewChild('menuCheckbox') menuCheckbox!: ElementRef<HTMLInputElement>;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (!this.isMenuOpen) {
      this.menuCheckbox.nativeElement.checked = false;
    }
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.menuCheckbox.nativeElement.checked = false;
  }
}
